import { createSlice } from "@reduxjs/toolkit";

export const weatherPage = createSlice({
  name: "weather_page",
  initialState: {
    value: {
      status: false,
      data: {
        latitude: 0,
        longitude: 0,
        currentWeather: {},
        hourlyWeather: [],
        daysWeather: [],
      },
    },
  },
  reducers: {
    updateWeather: (state, action) => {
      state.value.status = true;
      state.value.data.latitude = action?.payload?.latitude;
      state.value.data.longitude = action?.payload?.longitude;
      state.value.data.currentWeather = action?.payload?.currentWeather;
      state.value.data.hourlyWeather = action?.payload?.hourlyWeather;
      state.value.data.daysWeather = action?.payload?.daysWeather;
    },
    resetWeatherPage: (state, action) => {
      state.value = {
        status: false,
        data: {
          latitude: 0,
          longitude: 0,
          currentWeather: {},
          hourlyWeather: [],
          daysWeather: [],
        },
      };
    },
  },
});

export const { updateWeather } = weatherPage.actions;

export default weatherPage.reducer;
